<div class="mc-avatar-tooltip-container" [matTooltip]="branchName" matTooltipClass="mc-tooltip-multiline" [matTooltipDisabled]="disabledTooltip || !branchName">
  <a *ngIf="showAvatar && isLink() && !isImageDisabled()" class="mc-avatar-container" [routerLink]="routeCommands" (click)="navigate.emit()">
    <mat-icon class="mc-avatar-icon mc-avatar-icon-bordered" fontSet="project-titan" fontIcon="icon-branching"></mat-icon>
  </a>
  <div *ngIf="showAvatar && (!isLink() || isImageDisabled())" class="mc-avatar-container">
    <mat-icon class="mc-avatar-icon mc-avatar-icon-bordered" fontSet="project-titan" fontIcon="icon-branching"></mat-icon>
  </div>

  <a *ngIf="showName && isLink() && !isNameDisabled()" href="#" class="mc-avatar-name" [routerLink]="routeCommands" (click)="navigate.emit()">{{ displayText() }}</a>

  <span *ngIf="showName && (!isLink() || isNameDisabled())" class="mc-avatar-name">{{ displayText() }}</span>
</div>